import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ToastProvider } from '@/components/ui/Toast'
import { JoinPage } from '@/pages/Join'
import { BracketPage } from '@/pages/Bracket'
import { LeaderboardPage } from '@/pages/Leaderboard'
import { AdminDashboard } from '@/pages/AdminDashboard'
import { ChampionPickPage } from '@/pages/ChampionPick'
import { ChampionBoardPage } from '@/pages/ChampionBoard'
import { ForgotPasswordPage } from '@/pages/ForgotPassword'
import { ResetPasswordPage } from '@/pages/ResetPassword'
import { StandingsPage } from '@/pages/Standings'

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/join" element={<JoinPage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/bracket" element={<BracketPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/champion" element={<ChampionPickPage />} />
          <Route path="/champion-board" element={<ChampionBoardPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/standings" element={<StandingsPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/" element={<Navigate to="/bracket" replace />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  )
}
